import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO43 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK004-3.jpg"
      
      alt="Reserved avatar"

    />
  )
}

export default ImageMO43
